<template>
    <section class="mead-dashboard-filter-bar-popover sp-m">
        <!-- MultiConfigDisplay version to show multiple configuration components -->
        <div v-if="isMultiSection">
            <MultiConfigDisplay :lbl="selected_section.section_label"
                :children="selected_section.config_children"
                :config="internal_config"
                :sideBySideMode="true"
                :editMode="false"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="widgetType"
                :isV2MultiSection="isV2MultiSection"
                @onUpdate="onUpdate" />
        </div>
        <!-- Section has a componnet key. This is being deprecated -->
        <div v-else-if="hasComponentKey">
            <comp :config="internal_config"
                v-bind="selected_section.config"
                :is="sectionComponent"
                :sideBySideMode="true"
                :dashboardType="dashboardType"
                :dashboard="dashboard"
                :widgetType="widgetType"
                @onUpdate="onUpdate" />
        </div>
    </section>
</template>
<script>
import { guuid } from '@aretheyhappy/utils';
import DashboardConfigurationControllerMixin from '../../mixins/DashboardConfigurationControllerMixin';

export default {
    mixins: [DashboardConfigurationControllerMixin],
    props: {
        pubkey: {type: String, default: guuid()},
        selectedSction: {type: Object, default: () => {}},
    },
    methods: {
        onUpdate: function (key, val) {
            this.internal_config[key] = val;
            this.onSendUpdate(this.internal_config);
        },
        onSendUpdate: function (config) {
            MeadCommon.Flash.publish(`${this.pubkey}:widget_config_update`, config);
        }
    },
    created: function () {
        this.is_edit_mode = false;
        this.emit_invalid_configs = false;
        this.selected_section = this.selectedSction;
    }
}
</script>
<style lang="scss" scoped>
.mead-dashboard-filter-bar-popover {
    max-width: 40rem;
}
</style>